import * as c from '../constants/ApprovalRequestConstants'

const initialState = {
  sortColumn: null,
  sortDir: false,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case c.SET_APPROVAL_REQUEST_TABLE_SORT_COLUMN:
      return { ...state, sortColumn: payload }

    case c.SET_APPROVAL_REQUEST_TABLE_SORT_DIR: {
      console.log(`%%% set sort dir: ${payload}`)
      return { ...state, sortDir: payload }
    }

    case c.SET_APPROVAL_REQUEST_TABLE_SORT_COLUMN_AND_DIR:
      return { ...state, sortColumn: payload.column, sortDir: payload.direction }

    default:
      return state
  }
}
